import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Nav.module.css';
import { BorderButton, ConfirmButton, ContrastButton, PrimaryButton } from '../Buttons/Buttons';
import PropTypes from 'prop-types';
import LogoutButton from '../LogoutButton/LogoutButton';

const Nav = ({ visibilities, exit, confirm }) => {
  const classNames = visibilities.map(item => {
    return (item === 'true' ? 'normal' : 'hidden')
  });

  return (
    <nav>
      <div>
        {localStorage.getItem('token')
          ? <Link to='/' className={styles.logo}>BigBrain</Link>
          : <Link to='/login' className={styles.logo}>BigBrain</Link>}
      </div>
      <div>
        <Link to='/login' className={styles.path}>
          <PrimaryButton className={styles[classNames[0]]}>
            <span>Log in</span>
          </PrimaryButton>
        </Link>
        <Link to='/register' className={styles.path}>
          <ContrastButton className={styles[classNames[1]]}>
            <span>Register</span>
          </ContrastButton>
        </Link>
        <LogoutButton className={styles[classNames[2]]} />
        <BorderButton
          label='exit'
          className={styles[classNames[3]]}
          onClick={exit}
        >
          <span>Exit</span>
        </BorderButton>
        <ConfirmButton
          label='confirm'
          className={styles[classNames[4]]}
          onClick={confirm}
        >
          <span>Done</span>
        </ConfirmButton>
      </div>
    </nav>
  );
}

Nav.propTypes = {
  visibilities: PropTypes.array,
  exit: PropTypes.func,
  confirm: PropTypes.func,
};

export default Nav;
